import { createContext, FunctionComponent, useContext, useState } from 'react';
import { appConfig } from '../config/app.config';
import { OmitMethods } from '../types';

interface LifeCycleContextI {
	isOpened: boolean;
	setIsOpened: (isOpened: boolean) => void;
}

const initialState: OmitMethods<LifeCycleContextI> = {
	isOpened: process.env.NODE_ENV === 'development' || appConfig.isWebsite
};

export const LifeCycleContext = createContext(initialState as LifeCycleContextI);

export const LifeCycleProvider: FunctionComponent = ({ children }) => {
	const [isOpened, setIsOpened] = useState<boolean>(initialState.isOpened);
	return <LifeCycleContext.Provider value={{ isOpened, setIsOpened }}>{children}</LifeCycleContext.Provider>;
};

export function useLifeCycle() {
	return useContext(LifeCycleContext);
}
